export default "__VITE_ASSET__CtjHvdbP__"